export default __webpack_public_path__ + "static/media/process-download-tablet.cf11b466.svg";